module.exports = __webpack_public_path__ + "static/media/MealSettingsBlue.de9bfd98.svg";